const STORAGE_SLUG = '@KnowInDoc:devTenantSlug';
const STORAGE_MOCK_HOST = '@KnowInDoc:devMockHost';

export function isLocalDevHost(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1';
}

export function hasDevTenantContext(): boolean {
  if (!isLocalDevHost()) return false;
  return !!(
    sessionStorage.getItem(STORAGE_SLUG)?.trim() ||
    sessionStorage.getItem(STORAGE_MOCK_HOST)?.trim()
  );
}

export function initLocalDevTenantContext(searchParams?: URLSearchParams): void {
  if (typeof window === 'undefined') return;

  sessionStorage.removeItem(STORAGE_SLUG);
  sessionStorage.removeItem(STORAGE_MOCK_HOST);

  if (!isLocalDevHost()) return;

  const params = searchParams ?? new URLSearchParams(window.location.search);
  const urlSlug = params.get('tenantSlug')?.trim();
  const envSlug = process.env.REACT_APP_DEV_TENANT_SLUG?.trim();
  const envMock = process.env.REACT_APP_DEV_MOCK_HOST?.trim();

  if (urlSlug) {
    sessionStorage.setItem(STORAGE_SLUG, urlSlug);
    return;
  }
  if (envSlug) {
    sessionStorage.setItem(STORAGE_SLUG, envSlug);
    return;
  }
  if (envMock) {
    sessionStorage.setItem(STORAGE_MOCK_HOST, envMock);
  }
}

export function getDevTenantSlugFromStorage(): string | null {
  if (typeof window === 'undefined') return null;
  const v = sessionStorage.getItem(STORAGE_SLUG)?.trim();
  return v || null;
}

export function getDevMockHostFromStorage(): string | null {
  if (typeof window === 'undefined') return null;
  const v = sessionStorage.getItem(STORAGE_MOCK_HOST)?.trim();
  return v || null;
}
